<script>
import { mapGetters } from 'vuex';

import { multicurrencyMixin } from '@/mixins/offices';

import './index.css';

export default {
  name: 'push-tariff',
  mixins: [multicurrencyMixin],
  props: {
    currentTariff: Number
  },
  computed: {
    ...mapGetters({
      countryData: 'GET_COUNTRY_DATA',
      getFixed: 'GET_FIXED'
    }),
    currencySymbol() {
      return !this.isM11yOfficeMixin ? this.countryData.currencySymbol : '';
    },
    getFormatedPrice() {
      return `${this.currentTariff.toFixed(4)} ${this.currencySymbol}`;
    }
  }
};
</script>

<template>
  <div class="push-tariff">
    <div class="push-tariff__card push-tariff__card_background-wave">
      <div class="push-tariff__caption">{{ $t('fe.tariff.viber.youtariff') | capitalize }}</div>
      <div class="push-tariff__details">
        <div class="push-tariff__name">{{ $t('fe.tariff.viber.bysender') | capitalize }}</div>
        <div class="push-tariff__fee">
          {{ getFormatedPrice }}
          <span class="push-tariff__label">/ {{ $t('fe.push.message') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
